import React from 'react';
import { styled } from '@mui/material';

import InstructorNotifications from 'components/organisms/Profile/Notifications/InstructorNotifications';
import { Checkbox, Stack, Text } from 'shell/components';

const TabletNotifications = ({ timeZone, preferences, preferenceListItems, role, onChange }) => {
    return (
        <CustomStack spacing={4}>
            <Text variant={'sh2'} weight={'semibold'}>
                Notification Preferences
            </Text>
            {preferenceListItems.map(({ key, value, title, description }) => (
                <CustomCheckbox
                    key={key}
                    checked={value}
                    label={
                        <Stack sx={{ py: 1 }} spacing={2}>
                            <Text variant={'p1'}>{title}</Text>
                            <Text color={'light'} variant={'p2'}>
                                {description}
                            </Text>
                        </Stack>
                    }
                    onChange={(_, checked) => onChange(key, checked)}
                />
            ))}
            {role === 'instructor' && (
                <InstructorNotifications timeZone={timeZone} preferences={preferences} onChange={onChange} />
            )}
        </CustomStack>
    );
};

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        padding: theme.spacing(5),
        maxWidth: theme.spacing(180),
    };
});

const CustomCheckbox = styled(Checkbox)(() => {
    return {
        '& > .MuiCheckbox-root': {
            alignSelf: 'flex-start',
        },
    };
});

export default TabletNotifications;
